/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type formuleSpace_formules$ref: FragmentReference;
declare export opaque type formuleSpace_formules$fragmentType: formuleSpace_formules$ref;
export type formuleSpace_formules = $ReadOnlyArray<{|
  +id: string,
  +spaceOnly: ?boolean,
  +day: ?boolean,
  +title: ?string,
  +slug: ?string,
  +description: ?string,
  +excl_tax: ?number,
  +minperson: ?number,
  +type: ?string,
  +index: ?number,
  +category: ?string,
  +groups: ?$ReadOnlyArray<?{|
    +title: ?string,
    +extras: ?string,
    +order: ?number,
    +icon: ?string,
  |}>,
  +extras: ?$ReadOnlyArray<?{|
    +slug: ?string,
    +title: ?string,
    +icon: ?string,
    +description: ?string,
    +partnerRef: ?string,
    +rules: ?{|
      +until: ?number
    |},
  |}>,
  +$refType: formuleSpace_formules$ref,
|}>;
export type formuleSpace_formules$data = formuleSpace_formules;
export type formuleSpace_formules$key = $ReadOnlyArray<{
  +$data?: formuleSpace_formules$data,
  +$fragmentRefs: formuleSpace_formules$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "formuleSpace_formules",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spaceOnly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excl_tax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minperson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "index",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormuleGroup",
      "kind": "LinkedField",
      "name": "groups",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extras",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceHostServices",
      "kind": "LinkedField",
      "name": "extras",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "partnerRef",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceHostServicePrice",
          "kind": "LinkedField",
          "name": "rules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "until",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceFormule",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '4720a0e6d1ad2dc73f1f6c08be29e5ea';

module.exports = node;
